import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import {
    StateType,
    hasProjectAccess,
} from "client/utils"
import {
    PRM_STUDY_SESSION,
    StoreType,
    StudySessionProps,
    LoadStudySessionById,
    setStudySessionView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"

import Form from "./form"

const View = ({
    sessionId = null,
}: StudySessionProps) => {
    const session = useSelector((state: StoreType) => state.studySession.sessionView)
    const reloadView = useSelector((state: StoreType) => state.studySession.reloadView)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadStudySessionById(sessionId, project.id)
        .then((res) => {
            dispatch(setStudySessionView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = hasProjectAccess(PRM_STUDY_SESSION, VIEW)

    if (!viewAccess) return <AccessDenied />
    if (!session) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewSession} # ${session.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <Form />
            </PageContent>
        </Container>
    )
}
export default View
